import { Box, FormControlLabel, Grid, InputLabel, MenuItem, Switch, TextField } from '@material-ui/core'
import { ChangeEvent } from 'react'
import { IOProps } from 'react-compose-io'
import { Controller } from 'react-hook-form'
import { NOTAFISCAL, NOTAFISCAL_INFO } from '../../../constants/notaFiscal'
import { TooltipComponent } from '../../Tooltip/Tooltip'
import { FieldsDescricaoNotaFiscalIO } from './FieldsDescricaoNotaFiscal.IO'

export type FieldsDescricaoNotaFiscalProps = {
  isEdicao?: boolean
  ativo?: boolean
  mudarStatusAtivo?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void
}

export function FieldsDescricaoNotaFiscalView({
  _io,
  ativo,
  mudarStatusAtivo,
  isEdicao
}: IOProps<FieldsDescricaoNotaFiscalIO, FieldsDescricaoNotaFiscalProps>) {
  const { FormControl, FormGroup, Fieldset, FormLabel, SelectPadrao } = _io.styles

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={12} md={3}>
        <FormGroup>
          <Controller
            render={({ field }) => <TextField fullWidth {...field} size="small" label="Título da regra" variant="outlined" />}
            name="nomeRegra"
            control={_io.control}
          />
          <TooltipComponent texto={NOTAFISCAL_INFO.tituloRegra} />
        </FormGroup>
      </Grid>
      {isEdicao && (
        <>
          <Grid container item sm={12} md={6} justifyContent="flex-end" alignItems="center">
            <Controller
              name="ativo"
              control={_io.control}
              render={({ field }) => (
                <FormControlLabel
                  control={<Switch {...field} color="primary" defaultChecked={ativo} onChange={mudarStatusAtivo} />}
                  label={ativo ? 'Ativado' : 'Desativado'}
                />
              )}
            />
          </Grid>
        </>
      )}
      <Fieldset>
        <Grid item sm={12} md={12}>
          <FormGroup>
            <FormLabel>{NOTAFISCAL.formularioTipoTemplate}</FormLabel>
            <Box>
              <Controller
                render={({ field }) => (
                  <FormControl>
                    <InputLabel>Selecione</InputLabel>
                    <SelectPadrao {...field} id="to" label="Selecione">
                      <MenuItem value="PedidoPlanilha">Pedido planilha</MenuItem>
                      <MenuItem value="ValorNota">Valor Nota</MenuItem>
                    </SelectPadrao>
                  </FormControl>
                )}
                name="campo"
                control={_io.control}
              />
            </Box>
            <TooltipComponent texto={NOTAFISCAL_INFO.tipoTemplate} />
          </FormGroup>
        </Grid>
      </Fieldset>
    </Grid>
  )
}
